export const REPORT_QUIZ_DOMAINS = [
    'quiz.lingopass-edu.com/pl',
    'dailyjournalhub.com/bg-language-program-quiz-ab',
    'dailyjournalhub.com/lt-language-program-quiz-ab',
    'dailyjournalhub.com/lv-language-program-quiz-ab'

];
